import {useQuery} from "@tanstack/react-query";
import {
    PartnerService,
    PartnerServicesApi,
} from "@devour/client";
import getConfig from "@/utils/getConfig";

async function fetchPartnerService(utmSource: string): Promise<PartnerService> {
    return await new PartnerServicesApi(getConfig()).getPartnerServicesSingle({
        utmSource: utmSource,
    });
}

function getPartnerServiceQuery(utmSource: string) {
    return {
        queryKey: [
            "get-partner-service",
            utmSource,
        ],
        queryFn: () => fetchPartnerService(utmSource),
        staleTime: 60000,
        enabled: Boolean(utmSource),
    } as const;
}

export function useGetPartnerService(utmSource: string) {
    return useQuery(getPartnerServiceQuery(utmSource));
}
